"use client";
import React, { useEffect, useState } from "react";
import Carousel from "react-bootstrap/Carousel";
import Link from "next/link";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Stack from "react-bootstrap/Stack";
import Ratio from "react-bootstrap/Ratio";
import FallbackImage from "@/components/FallbackImage";
import Placeholder from "react-bootstrap/Placeholder";
import "@/styles/SlideCarousel.scss";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import {
  fetchListingData,
  modalHelper,
} from "@/components/services/QueryDataHelper";

export default function SlideCarousel(props: any) {
  const queryClient = useQueryClient();
  const { setModal, setModalVideo } = modalHelper(queryClient);
  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex: number, e: any) => {
    setIndex(selectedIndex);
  };

  const { slideCount = 1, slideType = "featured", queryValue = "res" } = props;
  const {
    data: currentData,
    error,
    isLoading,
    isFetching
  } = useQuery({
    queryKey: ["LISTING-DATA", queryValue],
    queryFn: () => fetchListingData(slideType, queryValue),
    staleTime: 300000
  });
  let Items = [];

  if (isLoading || isFetching) {
    Items = [];
    let Slides = [];
    for (let x = 0; x < slideCount; x++) {
      Slides.push(
        <Col lg={3} key={x}>
          <Card
            className="mb-4"
            title="Loading properties"
            aria-label="Loading properties"
          >
            <div className="loading-wrapper">
              <div className="loading-ellipsis">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
            <Card.Body>
              {/* 
// @ts-ignore */}
              <Placeholder as={Card.Title} animation="glow">
                <Placeholder xs={7} /> <Placeholder xs={4} />
                <Placeholder xs={5} /> <Placeholder xs={3} />{" "}
                <Placeholder xs={3} />
                <Placeholder xs={6} /> <Placeholder xs={5} />
              </Placeholder>
            </Card.Body>
          </Card>
        </Col>
      );
    }

    Items.push(
      <Carousel.Item key={1}>
        <Row>{Slides}</Row>
      </Carousel.Item>
    );
    if (props.cardWrapper) {
      return (
        <Card bg={props.bg}>
          <Card.Body>
            <Carousel
              className={props.className}
              controls={props.controls}
              activeIndex={index}
              onSelect={handleSelect}
            >
              {Items}
            </Carousel>
          </Card.Body>
        </Card>
      );
    } else {
      return (
        <Carousel
          className={props.className}
          controls={props.controls}
          activeIndex={index}
          onSelect={handleSelect}
        >
          {Items}
        </Carousel>
      );
    }
  }
  if (error) return <div>An error occurred: {(error as Error).message}</div>;
  if (currentData) {
    Items = [];
    if (slideType == "listing") {
      if(currentData.Images) {
      const Slides = (currentData.Images || []).map((img:string, i:number) => {
        return (
          <Col key={i}>
            <FallbackImage
              // className="d-block w-100"
              alt={`home for sale in ${
                currentData.SubdivisionName
                  ? currentData.SubdivisionName
                  : currentData.CountyOrPerish
              }`}
              aria-label={`home for sale in ${
                currentData.SubdivisionName
                  ? currentData.SubdivisionName
                  : currentData.CountyOrPerish
              }`}
              src={`${currentData.BaseImageURL}homes-for-sale-${
                currentData.SubdivisionName
                  ? encodeURIComponent(
                      currentData.SubdivisionName.toLowerCase()
                        .replaceAll(" & ", "-and-")
                        .replaceAll(" ", "-")
                        .replaceAll("_", "-")
                    )
                  : encodeURIComponent(
                      currentData.CountyOrPerish.toLowerCase()
                        .replaceAll(" ", "-")
                        .replaceAll("_", "-")
                    )
              }_${img}`}
              // src={`${currentData.BaseImageURL}${img}`}              
              fallbackSrc="/assets/images/no-image.jpg"
            />
          </Col>
        );
      });

      for (
        let x = Slides.length > 1 ? 1 : 0;
        x < Math.ceil(Slides.length / slideCount);
        x++
      ) {
        Items.push(
          <Carousel.Item key={x}>
            <Row>
              {Slides.filter((card: any, idx: number) => {
                return idx < slideCount * (x + 1) && idx + 1 > slideCount * x;
              })}
            </Row>
          </Carousel.Item>
        );
      }
    }
    else
    {
      return null;
    }
    } else if (slideType == "images") {
      const Slides = (currentData.Images || []).map((img:string, i:number) => {
        return (
          <Col lg={3} key={i}>
            <Card>
              <Ratio aspectRatio="4x3">
                <Card.Img
                  title={`home for sale in ${
                    currentData.SubdivisionName
                      ? currentData.SubdivisionName
                      : currentData.CountyOrPerish
                  }`}
                  alt={`home for sale in ${
                    currentData.SubdivisionName
                      ? currentData.SubdivisionName
                      : currentData.CountyOrPerish
                  }`}
                  aria-label={`home for sale in ${
                    currentData.SubdivisionName
                      ? currentData.SubdivisionName
                      : currentData.CountyOrPerish
                  }`}
                  src={`${currentData.BaseImageURL}homes-for-sale-${
                    currentData.SubdivisionName
                      ? encodeURIComponent(
                          currentData.SubdivisionName.toLowerCase()
                            .replaceAll(" & ", "-and-")
                            .replaceAll(" ", "-")
                            .replaceAll("_", "-")
                        )
                      : encodeURIComponent(
                          currentData.CountyOrPerish.toLowerCase()
                            .replaceAll(" ", "-")
                            .replaceAll("_", "-")
                        )
                  }_${img}`}
                />
              </Ratio>
            </Card>
          </Col>
        );
      });
      for (
        let x = Slides.length > 1 ? 1 : 0;
        x < Math.ceil(Slides.length / slideCount);
        x++
      ) {
        Items.push(
          <Carousel.Item key={x}>
            <Row>
              {Slides.filter((card: any, idx: number) => {
                return idx < slideCount * (x + 1) && idx + 1 > slideCount * x;
              })}
            </Row>
          </Carousel.Item>
        );
      }
    } else {
      const Slides = (currentData || []).map((item: any, idx: number) => {
        return (
          <Col lg={3} key={idx}>
            <Link
              href={`/homes-for-sale/${
                item.SubdivisionName
                  ? encodeURIComponent(
                      item.SubdivisionName.toLowerCase()
                        .replaceAll(" & ", "-and-")
                        .replaceAll(" ", "-")
                    )
                  : encodeURIComponent(
                      item.CountyOrPerish.toLowerCase().replaceAll(" ", "-")
                    )
              }/${item.ListingId}`}
              title={`home for sale in ${
                item.SubdivisionName
                  ? item.SubdivisionName
                  : item.CountyOrPerish
              }`}
              aria-label={`home for sale in ${
                item.SubdivisionName
                  ? item.SubdivisionName
                  : item.CountyOrPerish
              }`}
            >
              <Card className="mb-4">
                <Ratio aspectRatio="4x3">
                  <FallbackImage
                    className="rounded-top"
                    alt={`home for sale in ${
                      item.SubdivisionName
                        ? item.SubdivisionName
                        : item.CountyOrPerish
                    }`}
                    aria-label={`home for sale in ${
                      item.SubdivisionName
                        ? item.SubdivisionName
                        : item.CountyOrPerish
                    }`}
                    src={`${item.BaseImageURL}homes-for-sale-${
                      item.SubdivisionName
                        ? encodeURIComponent(
                            item.SubdivisionName.toLowerCase()
                              .replaceAll(" & ", "-and-")
                              .replaceAll(" ", "-")
                              .replaceAll("_", "-")
                          )
                        : item.CountyOrPerish.toLowerCase()
                            .replaceAll(" ", "-")
                            .replaceAll("_", "-")
                    }_1.jpg`}
                    // src={`${item.BaseImageURL}1.jpg`}                    
                    fallbackSrc="/assets/images/no-image.jpg"
                  />
                </Ratio>
                <Card.Body>
                  <Card.Text as="div">
                    <Stack gap={2} className="align-items-start">
                      <div>
                        Price:{" "}
                        <b>
                          {new Intl.NumberFormat("en-US", {
                            currency: "USD",
                            style: "currency",
                            maximumFractionDigits: 0,
                            minimumFractionDigits: 0,
                          }).format(item.ListPrice)}
                        </b>{" "}
                        / Built: <b>{item.YearBuilt}</b>
                      </div>
                      <div>
                        Sqft Living:{" "}
                        <b>
                          {new Intl.NumberFormat("en-US").format(
                            item.LivingArea
                          )}
                        </b>{" "}
                        / Beds:{" "}
                        <b>
                          {new Intl.NumberFormat("en-US", {
                            maximumFractionDigits: 2,
                            minimumFractionDigits: 0,
                          }).format(item.BedroomsTotal)}
                        </b>{" "}
                        / Baths:{" "}
                        <b>
                          {new Intl.NumberFormat("en-US", {
                            maximumFractionDigits: 2,
                            minimumFractionDigits: 0,
                          }).format(item.BathroomsTotalInteger)}
                        </b>
                      </div>
                      <div>
                        Garage: <b>{item.GarageSpaces}</b> / Acres:{" "}
                        <b>{item.LotSizeAcres}</b>
                      </div>
                    </Stack>
                  </Card.Text>
                </Card.Body>
              </Card>
            </Link>
          </Col>
        );
      });
      for (let x = 0; x < Math.ceil(currentData?.length / slideCount); x++) {
        Items.push(
          <Carousel.Item key={x}>
            <Row>
              {Slides.filter((card: any, idx: number) => {
                return idx < slideCount * (x + 1) && idx + 1 > slideCount * x;
              })}
            </Row>
          </Carousel.Item>
        );
      }
    }
    if (props.cardWrapper) {
      return (
        <Card bg={props.bg}>
          <Card.Body>
            <Carousel
              className={props.className}
              controls={props.controls}
              activeIndex={index}
              onSelect={handleSelect}
            >
              {Items}
            </Carousel>
          </Card.Body>
        </Card>
      );
    } else {
      return (
        <Carousel
          className={props.className}
          controls={props.controls}
          activeIndex={index}
          onSelect={handleSelect}
        >
          {Items}
        </Carousel>
      );
    }
  } else return null;
}
